import React from 'react'
import { useTranslation } from 'react-i18next'
import logoIconRu from 'icons/logo/company_logo_ru.png'
import logoIconEn from 'icons/logo/company_logo_en.png'

const Footer = () => {
    const {t, i18n} = useTranslation();

    const footerLinks = [
        {
            title: t("appBase.Footer.legalInformation"),
            items: [
                {
                    label: t("appBase.Footer.userAgreement"),
                    href: "/agreement.pdf"
                },
                {
                    label: t("appBase.Footer.privacy"),
                    href: "/personal.pdf"
                },
            ],
        },
        {
            title: t("appBase.Footer.backgroundInformation"),
            items: [
                {
                    label: t("appBase.Footer.adminGuide"),
                    href: "/materials/227/404/5092" 
                },
                {
                    label: t("appBase.Footer.userGuide"),
                    href: "/materials/308/320/4078"
                },
                {
                    label: t("appBase.Footer.support"),
                    href: "https://t.me/orbitaChallengeBot"
                },
            ],
        },
        {
            title: t("appBase.Footer.about"),
            items: [
                {
                    label: t("appBase.Footer.info"),
                    href: i18n.resolvedLanguage === "ru" ? "https://introsat.ru/orbita": "https://introsat.com/orbita" 
                },
                {
                    label: t("appBase.Footer.contacts"),
                    href: i18n.resolvedLanguage === "ru" ? "https://introsat.ru/contact": "https://introsat.com/contact"
                },
            ],
        },
    ];

    return (
    <footer className="footer">
        <div className="container">
            <div className="footer-links">
                {footerLinks.map((col, idx) => (
                    <div className="footer-column" key={idx}>
                        <h4>{col.title}</h4>
                        <ul>
                        {col.items.map((link, i) => (
                            <li key={i}>
                                {link.onClick ? (
                                    <span onClick={link.onClick} className="footer-link-btn">
                                        {link.label}
                                    </span>
                                ) : (
                                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                                      {link.label}
                                    </a>
                                )}
                            </li>
                        ))}
                        </ul>
                    </div>
                ))}

                <div className="footer-logo">
                    <a href={i18n.resolvedLanguage === "ru" ? "https://introsat.ru": "https://introsat.com"} target="_blank" rel="noopener noreferrer">
                        <img className="img-fluid" src={i18n.resolvedLanguage === "ru" ? logoIconRu : logoIconEn} alt=""/>
                        {/*<img src="https://nsppo.ru/upload/vars/3a6/mv4teobv54yauqddqa9i7v1rmphlgux4.png" alt="Company Logo"/>*/}
                    </a>
                </div>
            </div>

            <hr/>

            <div className="footer-description">
                {t("appBase.Footer.description")}
            </div>

            <div className="footer-copy">
              © 2018 - 2025, {t("appBase.Footer.educationOfTheFuture")}. {t("appBase.Footer.allRightReserved")}
            </div>
        </div>
    </footer>
    );
};

export default Footer;